import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import Button from 'js/components/Button'
import Checkbox from 'js/components/Checkbox/Checkbox'
import Flexer from 'js/components/Flexer/Flexer'
import Modal from 'js/components/Modal/Modal'

type Props = {
    entity?: {
        title?: string
        isAttendingSubEvents?: boolean
        requireAttendParent?: boolean
        parent?: any
    }
    isVisible: boolean
    state: string
    onSubmit: (data: any) => Promise<void> | void
    onClose: () => void
    loading: boolean
}

const LeaveGuestListModal = ({
    entity = {},
    isVisible,
    state,
    onSubmit,
    onClose,
    loading,
}: Props) => {
    const { t } = useTranslation()

    const { title, isAttendingSubEvents, requireAttendParent } = entity

    const [updateSubEvents, setUpdateSubEvents] = useState(
        requireAttendParent ? true : false,
    )

    const handleCancel = () => {
        onClose()
    }

    const handleSubmit = async () => {
        await onSubmit({ state, updateSubEvents })
        onClose()
    }

    let leaveMessage = ''

    if (state === 'online' && !requireAttendParent) {
        leaveMessage = t('entity-event.exit-physical-guest-list-confirm', {
            title,
        })
    } else if (state !== 'online' && !requireAttendParent) {
        leaveMessage = t('entity-event.exit-guest-list-confirm', {
            title,
        })
    } else if (state === 'online' && requireAttendParent) {
        leaveMessage = t(
            'entity-event.exit-physical-guest-list-including-sub-events-confirm',
            {
                title,
            },
        )
    } else if (state !== 'online' && requireAttendParent) {
        leaveMessage = t(
            'entity-event.exit-guest-list-including-sub-events-confirm',
            {
                title,
            },
        )
    }

    return (
        <Modal
            size="small"
            isVisible={isVisible}
            onClose={onClose}
            title={t('entity-event.exit-guest-list')}
        >
            {leaveMessage}

            {isAttendingSubEvents && !requireAttendParent && (
                <Checkbox
                    name="updateSubEvents"
                    label={t('entity-event.exit-guest-list-all-activities')}
                    checked={updateSubEvents}
                    onChange={(evt) => setUpdateSubEvents(evt.target.checked)}
                    size="small"
                    style={{ marginTop: '8px' }}
                />
            )}

            <Flexer mt>
                <Button variant="tertiary" size="normal" onClick={handleCancel}>
                    {t('action.no-cancel')}
                </Button>
                <Button
                    size="normal"
                    variant="primary"
                    onClick={handleSubmit}
                    loading={loading}
                >
                    {t('action.yes-confirm')}
                </Button>
            </Flexer>
        </Modal>
    )
}

export default LeaveGuestListModal
